// Hidden-bug/validation math — docs/ARCHITECTURE_M0.md §5.5 (validation phase).

/** Closed-form probability first silicon works (zero critical escapes). Unit-testable. */
export function pFirstSiliconWorks(critLambda: number, coverage: number, escapeMult: number): number {
  return Math.exp(-critLambda * (1 - coverage) * escapeMult);
}

/** Effective escape rates entering a validation roll. */
export function escapeLambdas(args: {
  critLambda: number;
  minorLambda: number;
  coverage: number;
  escapeMult: number;
}): { crit: number; minor: number } {
  const exposure = (1 - args.coverage) * args.escapeMult;
  return { crit: args.critLambda * exposure, minor: args.minorLambda * exposure };
}
